// extracted by mini-css-extract-plugin
export default {"themeGrandFrais":"BlockRegulation_themeGrandFrais__Hi2TD","themeFresh":"BlockRegulation_themeFresh__npbV9","regulation":"BlockRegulation_regulation__YF+fp"};